import VoiceAndWavCloningImage from "../../Assets/Projects/VoiceAndWavCloningImage.png";
import GiveMeSQLImage from "../../Assets/Projects/givemesql.png";
import NRICM101_Map from "../../Assets/Projects/Taiwan-NRICM101-Map.png";
import kaggleCard from "../../Assets/Projects/Kaggle-Profile-Card-API.png";
import JavaScriptLanguageSwitcherImage from "../../Assets/Projects/JavaScriptLanguageSwitcher.png";
import MediumtoWb from "../../Assets/Projects/Embed-Medium-on-Website.png";

export const projects_list = [
  {
    "imgPath": VoiceAndWavCloningImage,
    "isBlog": false,
    "title": "Voice and Wav Cloning",
    "description": "Implemented a voice and wav cloning project that synthesizes high-quality speech audio from text inputs using advanced deep learning techniques. Utilized Python for backend processing and various machine learning frameworks.",
    "ghLink": "https://github.com/chienhsiang-hung/voice-and-wav-cloning",
    "demoLink": "https://chienhsiang-hung.github.io/blog/posts/2024/voice-and-wav-cloning/"
  },
  {
    "imgPath": GiveMeSQLImage,
    "isBlog": false,
    "title": "GiveMeSQL",
    "description": "Generate your SQL query with OpenAI and Vercel Edge Functions. Developed an SQL query generator which simplifies writing SQL queries. Features include query building using form inputs, syntax highlighting, and error handling. Utilized React for frontend and Node.js for backend.",
    "ghLink": "https://github.com/chienhsiang-hung/givemesql",
    "demoLink": "https://chienhsiang-hung.github.io/givemesql/"
  },
  {
    "imgPath": NRICM101_Map,
    "isBlog": false,
    "title": "Taiwan NRICM101 Map",
    "description": "Creator of a responsive med info map, shows the metadata of nearby clinics for those who were infected or weren’t, in need of finding the NRICM101 treatment for Covid-19 (average 1,000+ daily visitors). Integrated government data with Leaflet (open-source JavaScript map library), and hosted serverless using Vercel, GitHub, and MongoDB.",
    "ghLink": "https://github.com/chienhsiang-hung/NRICM101-map",
    "demoLink": "https://chienhsiang-hung.github.io/NRICM101-map/"
  },
  {
    "imgPath": kaggleCard,
    "isBlog": false,
    "title": "Kaggle Profile Card API",
    "description": "Developed an API by Web Scraping competition data and presented through designing on HTML and CSS / SVG (serves stainless by embedding through HTML or Markdown), deployed on Vercel with Python for Kagglers to display their Kaggle profile at any time, everywhere, and effortlessly. It’s used in more than 10 countries.",
    "ghLink": "https://github.com/chienhsiang-hung/kaggle-profile-summary-card",
    "demoLink": "https://chienhsiang-hung.github.io/kaggle-profile-summary-card/"
  },
  {
    "imgPath": JavaScriptLanguageSwitcherImage,
    "isBlog": false,
    "title": "JavaScript Language Switcher",
    "description": "A simple JavaScript language switcher that allows users to easily switch between multiple languages on websites. Supports dynamic language switching without page reloads. The project uses pure JavaScript and is lightweight, making it easy to integrate into any project.",
    "ghLink": "https://github.com/chienhsiang-hung/javascript-language-switcher",
    "demoLink": "https://chienhsiang-hung.github.io/javascript-language-switcher/"
  },
  {
    "imgPath": MediumtoWb,
    "isBlog": false,
    "title": "Embed Medium on Website",
    "description": "This is a free and simple guide through that you can finally embed your medium grid to your website by yourself without worrying about your personal info being packed by 3rd party APIs. #javascript #jquery",
    "ghLink": "https://github.com/chienhsiang-hung/embed-medium-blog-on-website",
    "demoLink": "https://chienhsiang-hung.github.io/embed-medium-blog-on-website/RWD"
  }
]